// extracted by mini-css-extract-plugin
export default {"truncate":"MenuCartSeat_truncate__guW4O"};